




















































































































































































































import { Component, Mixins, Prop, Vue } from 'vue-property-decorator'
import UnitDetailMixin from '@/components/mixins/UnitDetailListMixin.vue'
import CardModel from '@/_models/CardModel'

@Component({
  components: {},
})
export default class FloorList extends Mixins(UnitDetailMixin) {
  public filedNameLUT: any = {
    _id: 'UUID',
    san_id: 'label.san_id',
    user_name: 'label.username',
    user_id: 'label.user_id',
    category_name: 'label.category_name',
    location_name: 'label.possition',
    lon: 'label.lon',
    lat: 'label.lat',
    floor_name: 'label.floor',
  }

  public pageFilters: any = {
    currentPage: 1,
    perPage: 10,
    selectedFilter: 'san_id',
    searchQuery: '',
    activeTab: 0, // 0: carried, 1: static
  }

  // computed
  get cards(): CardModel[] {
    const cards = this.$store.state.units.all.cards
    this.numofPage = Math.ceil(cards.length / this.pageFilters.perPage)

    return cards
  }

  get totalCardsStatic(): number {
    return this.cards.filter(
      (item: CardModel) => item.card_type === 'static'
    ).length
  }

  get totalCardsCarried(): number {
    return this.cards.filter(
      (item: CardModel) => item.card_type === 'carried'
    ).length
  }

  get filteredData(): CardModel[] {
    const targetField: string = this.pageFilters.selectedFilter
    if (!this.cards) {
      return []
    }

    return this.cards.filter((item: any): boolean => {
      const searchKey =
        String(item[targetField])
          .toLowerCase()
          .indexOf(this.pageFilters.searchQuery.toString().toLowerCase()) !==
          -1 || item._id === this.pageFilters.searchQuery // Can search by uuid

      const validCarried =
        item.card_type === 'carried' && this.pageFilters.activeTab === 0
      const validStatic =
        item.card_type === 'static' && this.pageFilters.activeTab === 1

      return searchKey && (validCarried || validStatic)
    })
  }

  public confirmMultiDelete() {
    const ids = this.checkedRows.map((item: CardModel) => item._id)
    const labels = this.checkedRows.map((item: CardModel) => `[${item.card_type}] - ${item._id}`)
    this.handleConfirmMultipleDelete('card', ids, labels)
  }

  public confirmSingleDelete(selectedItem: CardModel) {
    const ids = [selectedItem._id]
    const labels = [`[${selectedItem.card_type}] - ${selectedItem._id}`]
    this.handleConfirmMultipleDelete('card', ids, labels)
  }

  private created() {
    this.$store.dispatch('units/getAllCards', this.selected)
  }
}
